import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zM4.66624 8.80424l6.49386 6.49386c.781.781.781 2.048 0 2.829l-1.51824 1.5182C10.3876 19.8758 11.1796 20 12 20c4.0724 0 7.4442-3.0592 7.9378-7h-7.9339c-1.782 0-2.674-2.154-1.414-3.414l4.821-4.82181C14.3757 4.27421 13.2192 4 12 4 8.72445 4 5.90218 5.9791 4.66624 8.80424z",
    fill: "currentColor"
  }));
});